// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__bPswI"};